import quercusApi from '../apis/quercusApi';

export const deleteType = async (url) => {
    return quercusApi.delete(url, {
        responseType: 'blob',
    });
};
